<template>
  <div>
    <div class="col-12">
      <div class="row">
        <div
          :class="columnListPanels"
          id="list-panels"
          style="background: #fff; padding: 0;"
        >
          <div>
            <div id="title" style="background: #fff;">
              <div class="container">
                <div class="row">
                  <div
                    class="col-12"
                    style="padding: 0; border-bottom: 2px solid #f1f1f1;"
                  >
                    <p>{{ $t('panel.pageHome.titlePage')}}</p>

                    <b-button
                      variant="outline-primary"
                      slot=""
                      id="button-hide"
                      @click="hide"
                    >
                      <font-awesome-icon :icon="['fas', 'angle-left']" />
                    </b-button>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12" style="padding: 0; position: absolute; height: 100%">
                    <div style="height: 100%; overflow-y: auto; position: relative; padding-bottom: 150px">
                    <template>
                      <div
                        class="col-12"
                        style="
                          padding-left: 40px;
                          padding-right: 40px;
                          padding-top: 12px;
                          padding-bottom: 5px;
                        "
                      >
                        <div style="display: flex;">
                          <input
                            style="width: 80%; line-height: 2;"
                            class="form-control"
                            type="text"
                            v-model="searchPainel"
                            :placeholder="`${$t('panel.pageHome.findPanel')}`"
                          />
                          <template
                            v-if="userProfile.permissions.panels.create_panel"
                          >
                            <b-button
                              class="btn btn-more-search"
                              variant="primary"
                              v-b-modal.modal-switch-option
                            >
                              <font-awesome-icon
                                style="font-size: 28px;"
                                :icon="['fas', 'plus-circle']"
                              />
                            </b-button>
                          </template>
                        </div>
                      </div>

                      <div class="col-12 mt-2" style="padding: 0;">
                        <div class="mt-2">
                          <template v-for="(panel, index) in listPanels">
                            <b-list-group
                              :key="index"
                              style="
                                width: 100%;
                                background: #fff;
                                border: none;
                              "
                            >
                              <b-list-group-item
                                class="panel-item"
                                v-bind:class="{
                                  active: $route.query.idpanel == panel._id,
                                }"
                                href="#"
                                :id="panel._id"
                                style="padding: 20px; line-height: 24px;"
                                @click="selectPanel(panel._id)"
                                >{{ panel.title }}</b-list-group-item
                              >
                            </b-list-group>
                          </template>
                        </div>
                      </div>
                    </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-button variant="outline-primary" id="button-show" @click="show">
              <font-awesome-icon :icon="['fas', 'angle-right']" />
            </b-button>
          </div>
        </div>
        <div :class="columnPanel" id="content-panels">
          <div>
            <div v-if="panelsInfo.length === 0" id="msg-no-panel">
              <p id="no-panel">
                {{ $t('panel.pageHome.noHavePanel')}}
              </p>
              <button v-b-modal.modal-switch-option class="add-panel">
                {{ $t('panel.pageHome.morePanel')}}
              </button>
            </div>

            <div v-else>
              <div
                class="col-12"
                style="padding-left: 28px; padding-right: 28px;"
                v-if="panel.panelInfo"
              >
                <div class="row bar">
                  <div class="col-9">
                    <span class="title-bar"
                      >{{panel.panelInfo.title}} - Overview </span
                    >
                    <b-button class="btn-popover" id="popover-target-1">
                      <font-awesome-icon :icon="['fas', 'chevron-down']" />
                    </b-button>

                    <b-popover target="popover-target-1" placement="down">
                      {{
                        panel.panelInfo
                          ? panel.panelInfo.description
                          : 'Sem descrição'
                      }}
                    </b-popover>

                    <span class="vertical-bar"></span>

                    <b-dropdown
                      size="lg"
                      variant="link"
                      toggle-class="text-decoration-none"
                      no-caret
                      style="margin-top: -8px;"
                      id="dropdown-custom"
                    >
                      <template #button-content>
                        <font-awesome-icon
                          class="title-bar"
                          :icon="['fas', 'pen']"
                        />
                        <span class="title-bar">{{ $t('panel.generalButtons.edit')}}</span>
                      </template>
                      <b-dropdown-item-button
                        @click="getPanelEditData"
                        v-b-modal.modal-edit-panel
                        :disabled="!userProfile.permissions.panels.edit_panel"
                        >{{ $t('panel.generalButtons.edit')}}</b-dropdown-item-button
                      >
                      <b-dropdown-item-button
                        :disabled="!userProfile.permissions.panels.delete_panel"
                        @click="deletePainel"
                        >{{ $t('panel.generalButtons.delete')}}</b-dropdown-item-button
                      >
                    </b-dropdown>

                    <b-button class="text" @click="reload"
                      ><font-awesome-icon :icon="['fas', 'sync-alt']" />
                      <span class="title-bar">{{ $t('panel.generalButtons.reload')}}</span>
                    </b-button>

                    <b-button
                      v-if="!enabledCustom"
                      @click="enabledCustomization('open')"
                      class="text"
                      ><font-awesome-icon :icon="['fas', 'lock']" />
                      <span class="title-bar">Customização</span>
                    </b-button>

                    <b-button
                      v-if="enabledCustom"
                      @click="!enabledCustomization('block')"
                      class="text"
                      ><font-awesome-icon :icon="['fas', 'lock-open']" />
                      <span class="title-bar">{{ $t('panel.generalButtons.custom')}}</span>
                    </b-button>
                  </div>

                  <div class="col-3" style="text-align: right;">
                    <b-button @click="showAddGraphic" variant="outline-primary"
                      >{{ $t('panel.pageHome.morePanel')}}</b-button
                    >
                  </div>
                </div>
              </div>

              <template v-if="!loading">
                <div
                  v-if="
                    panel.panelInfo && panel.panelInfo.configGraphs.length > 0
                  "
                  class="col-12 mt-2"
                  style="padding: 0;"
                >
                  <grid-layout
                    :layout.sync="panel.layout"
                    :col-num="12"
                    :row-height="30"
                    :is-draggable="draggable"
                    :is-resizable="resizable"
                    :vertical-compact="true"
                    :use-css-transforms="true"
                    style="margin: -8px;"
                    @layout-updated="layoutUpdatedEvent"
                    :margin="[20, 20]"
                  >
                    <grid-item
                      v-for="(item, index) in panel.layout"
                      :static="item.static"
                      :key="index"
                      :x="item.x"
                      :y="item.y"
                      :w="item.w"
                      :h="item.h"
                      :i="item.i"
                      :minW="item.minW"
                      :minH="item.minH"
                    >
                      <div
                        v-for="(dataGraph, i) in panel.panelInfo.configGraphs"
                        :key="i"
                        class="col-12"
                      >
                        <template v-if="dataGraph._id === item.idGraph">
                          <div
                            class="row pb-2 pt-3"
                            style="border-bottom: 4px solid #f1f1f1;"
                          >
                            <div class="col-10">
                              <p
                                style="
                                  font-weight: 600;
                                  font-size: 16px;
                                  margin: 0;
                                  padding-left: 10px;
                                "
                              >
                                {{ dataGraph ? dataGraph.title : 'Sem titulo' }}
                              </p>
                              <div
                                class="col-12"
                                style="display: flex; padding: 0;"
                              >
                                <template
                                  class="col-2"
                                  v-if="dataGraph.actionId"
                                >
                                  <p class="filters">
                                    {{ $t('dashboard.action')}}: {{ dataGraph.actionId.name }}
                                  </p>
                                </template>

                                <template class="col-2" v-if="dataGraph.metric">
                                  <p class="filters">
                                    {{ $t('dashboard.metric')}}: {{ dataGraph.metric }}
                                  </p>
                                </template>

                                <template
                                  class="col-3"
                                  v-if="dataGraph.actionGroupId"
                                >
                                  <p class="filters">
                                    {{ $t('dashboard.groupActions')}}:
                                    {{ dataGraph.actionGroupId.name }}
                                  </p>
                                </template>

                                <template class="col-2" v-if="dataGraph.ih1 && dataGraph.ih1.length > 0">
                                  <p class="filters" :id="`${'tooltip'-i}`">
                                    ih1: {{ dataGraph.ih1.length > 0 ? `${returnIh1Names(dataGraph.ih1[0])} ${dataGraph.ih1.length > 1 ? `+ ${dataGraph.ih1.length - 1}` : ''}` : '' }}
                                  </p>
                                  <b-tooltip
                                      :target="`${'tooltip'-i}`"
                                      placement="bottom"
                                    >
                                      <div v-for="(item, ih1Index) in dataGraph.ih1" :key="ih1Index">
                                        <p v-if="ih1Index > 0">
                                          ih1: {{ returnIh1Names(item) }}
                                        </p>
                                      </div>
                                    </b-tooltip>
                                </template>

                                <template
                                  class="col-3"
                                  v-if="
                                    dataGraph.indicator &&
                                    dataGraph.valueIndicator
                                  "
                                >
                                  <p class="filters">
                                    {{ dataGraph.indicator }}:
                                    {{ dataGraph.valueIndicator }}
                                  </p>
                                </template>

                                <template class="col-2" v-if="dataGraph.period">
                                  <p class="filters">
                                    {{ $t('panel.pageHome.date')}}
                                    {{ dataGraph.period }}
                                  </p>
                                </template>
                              </div>
                            </div>
                            <div class="col-2">
                              <div style="display: flex; float: right;">
                                <div style="margin-left: 10px;">
                                  <b-dropdown
                                    size="lg"
                                    variant="link"
                                    toggle-class="text-decoration-none"
                                    no-caret
                                  >
                                    <template #button-content>
                                      <font-awesome-icon
                                        :icon="['fas', 'ellipsis-v']"
                                        class="ellipsis-panel"
                                      />
                                    </template>
                                    <b-dropdown-item-button
                                      @click="showSidebarEdit(dataGraph._id)"
                                      >{{ $t('panel.generalButtons.edit')}}
                                    </b-dropdown-item-button>
                                    <b-dropdown-item-button
                                      @click="deleteCard(dataGraph._id)"
                                      >{{ $t('panel.generalButtons.delete')}}
                                    </b-dropdown-item-button>
                                  </b-dropdown>
                                </div>
                              </div>
                            </div>
                          </div>

                          <b-row
                            class="mt-2"
                            v-if="
                              dataGraph.report === 'Evolução de nps' ||
                              dataGraph.report === 'Evolução de percentuais' ||
                              dataGraph.report === 'Evolução de respostas' ||
                              dataGraph.report == 'Evolução de convites' ||
                              dataGraph.report == 'Evolução de csat' ||
                              dataGraph.report == 'Evolução de ces' ||
                              dataGraph.report == 'Evolução de Five Stars' ||
                              dataGraph.report === 'Evolução like/dislike'
                            "
                          >
                            <div
                              style="
                                position: absolute;
                                left: 20px;
                                z-index: 999;
                              "
                            >
                              <div class="custom-switch">
                                <input
                                  type="checkbox"
                                  :id="`swich-accumulated-value-${dataGraph._id}`"
                                  class="custom-control-input"
                                  v-on:change="setAccumulated($event, i)"
                                  v-model="dataGraph.accumulated"
                                />
                                <label
                                  style="font-size: 12px; line-height: 2;"
                                  class="custom-control-label"
                                  :for="`swich-accumulated-value-${dataGraph._id}`"
                                  >Acumulado</label
                                >
                              </div>
                            </div>
                            <b-col class="custom-buttons">
                              <div style="font-size: 12px;"> 
                                <b-button-group class="button-group">
                                  <b-button
                                    @click="filter(i, 'day')"
                                    class="buttons-filters"
                                    pill
                                    v-bind:class="{
                                      active: dataGraph.reportType == 'day',
                                    }"
                                    >{{ $t('panel.panelDataTime.day') }}</b-button
                                  >
                                  <b-button
                                    @click="filter(i, 'month')"
                                    class="buttons-filters"
                                    pill
                                    v-bind:class="{
                                      active: dataGraph.reportType
                                        ? dataGraph.reportType == 'month'
                                        : 'month',
                                    }"
                                    >{{ $t('panel.panelDataTime.month') }}</b-button
                                  >
                                  <b-button
                                    @click="filter(i, 'week')"
                                    class="buttons-filters"
                                    pill
                                    v-bind:class="{
                                      active: dataGraph.reportType == 'week',
                                    }"
                                    >{{ $t('panel.panelDataTime.week') }}</b-button
                                  >
                                  <b-button
                                    @click="filter(i, 'quarter')"
                                    class="buttons-filters"
                                    pill
                                    v-bind:class="{
                                      active: dataGraph.reportType == 'quarter',
                                    }"
                                    >{{ $t('panel.panelDataTime.quarter') }}</b-button
                                  >
                                </b-button-group>
                              </div>
                            </b-col>
                          </b-row>

                          <template
                            v-if="
                              dataGraph.report === 'Evolução de nps' ||
                              dataGraph.report === 'Evolução de csat' ||
                              dataGraph.report === 'Evolução de ces' ||
                              dataGraph.report === 'Evolução de Five Stars' ||
                              dataGraph.report === 'Evolução like/dislike'
                            "
                          >
                            <reportBasicColumn
                              :key="dataGraph._id"
                              :idReport="i.toString()"
                              :dataGraph="dataGraph"
                              :reportType="dataGraph.reportType"
                              :w="dataGraph.layout.w"
                              :h="dataGraph.layout.h"
                            />
                          </template>

                          <template
                            v-if="
                              dataGraph.report === 'Evolução de percentuais'
                            "
                          >
                            <reportEvolutionPercentage
                              :dataGraph="dataGraph"
                              :reportType="dataGraph.reportType"
                              :accumulated="dataGraph.accumulated"
                            />
                          </template>

                          <template
                            v-if="dataGraph.report === 'Evolução de respostas'"
                          >
                            <answersEvolution
                              :dataGraph="dataGraph"
                              :reportType="dataGraph.reportType"
                              :accumulated="dataGraph.accumulated"
                            />
                          </template>

                          <template
                            v-if="dataGraph.report === 'Comparativo de ação'"
                          >
                            <reportComparativeActions
                              :style="`overflow: auto; height: ${
                                item.h * 40
                              }px; overflow-x: hidden;`"
                              :dataGraph="dataGraph"
                            />
                          </template>

                          <template
                            v-if="dataGraph.report === 'Detratores recorrentes'"
                          >
                            <reportDetractor :dataGraph="dataGraph" />
                          </template>

                          <template
                            v-if="dataGraph.report === 'Ranking review'"
                          >
                            <reportAddQuestionReview
                              :style="`height: ${
                                item.h * 38
                              }px; overflow-x: hidden;`"
                              :dataGraph="dataGraph"
                            />
                          </template>

                          <template
                            v-if="dataGraph.report === 'Ranking escala 0 a 10'"
                          >
                            <reportAddQuestionCsat0a10
                              :style="`overflow-x: hidden; height: ${
                                item.h * 38
                              }px;`"
                              :dataGraph="dataGraph"
                            />
                          </template>

                          <template
                            v-if="dataGraph.report === 'Ranking like/dislike'"
                          >
                            <reportAddQuestionLikeDislike
                              :style="`overflow-x: hidden; height: ${
                                item.h * 38
                              }px;`"
                              :dataGraph="dataGraph"
                            />
                          </template>

                          <template
                            v-if="dataGraph.report === 'Ranking likert'"
                          >
                            <reportAddQuestionLikert
                              :style="`overflow-x: hidden; height: ${
                                item.h * 38
                              }px;`"
                              :dataGraph="dataGraph"
                            />
                          </template>

                          <template
                            v-if="dataGraph.report === 'Ranking emotion'"
                          >
                            <reportAddQuestionEmotion
                              :style="`overflow-x: hidden; height: ${
                                item.h * 38
                              }px;`"
                              :dataGraph="dataGraph"
                            />
                          </template>

                          <template v-if="dataGraph.report === 'Ranking nps'">
                            <reportAddQuestionNps
                              :style="`overflow-x: hidden; height: ${
                                item.h * 38
                              }px;`"
                              :dataGraph="dataGraph"
                            />
                          </template>

                          <template
                            v-if="dataGraph.report === 'Ranking Ces 1 a 5'"
                          >
                            <reportAddQuestionCes
                              :style="`overflow-x: hidden; height: ${
                                item.h * 38
                              }px;`"
                              :dataGraph="dataGraph"
                            />
                          </template>

                          <template
                            v-if="
                              dataGraph.report === 'Ranking multipla escolha'
                            "
                          >
                            <reportAddQuestionMultiple
                              :style="`overflow-x: hidden; height: ${
                                item.h * 38
                              }px;`"
                              :dataGraph="dataGraph"
                            />
                          </template>

                          <template
                            v-if="dataGraph.report === 'Relatório de mapa'"
                          >
                            <reportMapChart :dataGraph="dataGraph" />
                          </template>

                          <template
                            v-if="dataGraph.report === 'Score de sentimento'"
                          >
                            <reportScoreSentiment :dataGraph="dataGraph" />
                          </template>

                          <template
                            v-if="
                              dataGraph.report ===
                                'Classificação de sentimento' &&
                              dataGraph.graph === 'graph'
                            "
                          >
                            <reportSentimentRating
                              :h="dataGraph.layout.h"
                              :dataGraph="dataGraph"
                            />
                          </template>

                          <template
                            v-if="
                              dataGraph.report ===
                                'Classificação de sentimento' &&
                              dataGraph.graph === 'card'
                            "
                          >
                            <reportCardSentiment :dataGraph="dataGraph" />
                          </template>

                          <template
                            v-if="dataGraph.report === 'Evolução de sentimento'"
                          >
                            <reportEvolutionSentiment :dataGraph="dataGraph" />
                          </template>

                          <template
                            v-if="
                              dataGraph.report === 'Indicador de sentimento'
                            "
                          >
                            <reportIndicatorSentiment :dataGraph="dataGraph" />
                          </template>

                          <template
                            v-if="dataGraph.report === 'Top 5 keywords'"
                          >
                            <reportTopKeywords
                              :style="`height: ${
                                item.h * 40
                              }px; overflow-x: hidden;`"
                              :dataGraph="dataGraph"
                            />
                          </template>

                          <template v-if="dataGraph.report === 'Conversão'">
                            <reportConversion :dataGraph="dataGraph" />
                          </template>

                          <template
                            v-if="dataGraph.report === 'Status de tratativas'"
                          >
                            <reportTreamentStatus :dataGraph="dataGraph" />
                          </template>

                          <template
                            v-if="dataGraph.report === 'Tags de tratativas'"
                          >
                            <reportTreamentTags
                              :style="`height: ${
                                item.h * 37
                              }px; overflow-x: hidden;`"
                              :dataGraph="dataGraph"
                            />
                          </template>

                          <template
                            v-if="dataGraph.report === 'Nuvem de palavras'"
                          >
                            <reportWordCloud :dataGraph="dataGraph" />
                          </template>

                          <template
                            v-if="
                              dataGraph.report === 'Monitoramento de pesquisa'
                            "
                          >
                            <reportSurveyInvites
                              :style="`height: ${
                                item.h * 40
                              }px; overflow-x: hidden;`"
                              :dataGraph="dataGraph"
                            />
                          </template>

                          <template v-if="dataGraph.report === 'Categorias'">
                            <reportCategories
                              :style="`height: ${
                                item.h * 38
                              }px; overflow-x: hidden;`"
                              :dataGraph="dataGraph"
                            />
                          </template>

                          <template
                            v-if="dataGraph.report === 'Análise de indicador'"
                          >
                            <reportIndicatorsAnalyze
                              :style="`height: ${
                                item.h * 38
                              }px; overflow-x: hidden;`"
                              :dataGraph="dataGraph"
                            />
                          </template>

                          <template
                            v-if="
                              dataGraph.report === 'Análise por dispositivo'
                            "
                          >
                            <reportDeviceAnalyze :dataGraph="dataGraph" />
                          </template>

                          <template
                            v-if="dataGraph.report === 'Evolução de convites'"
                          >
                            <reportInvitesEvolution
                              :dataGraph="dataGraph"
                              :reportType="dataGraph.reportType"
                              :accumulated="dataGraph.accumulated"
                            />
                          </template>

                          <template
                            v-if="dataGraph.report === 'Resposta por canais'"
                          >
                            <reportAnswersByChannel :dataGraph="dataGraph" />
                          </template>

                          <template v-if="dataGraph.report === 'Indice Nps' ||
                            dataGraph.report === 'Indice Ces' ||
                            dataGraph.report === 'Indice Csat' ||
                            dataGraph.report === 'Indice Like/Dislike' ||
                            dataGraph.report === 'Indice Five Stars'">
                            <reportIndice :dataGraph="dataGraph"/>
                          </template>

                          <template v-if="dataGraph.report === 'Nps-Percentual' ||
                            dataGraph.report === 'Ces-Percentual' ||
                            dataGraph.report === 'Csat-Percentual' ||
                            dataGraph.report === 'Like/Dislike-Percentual' ||
                            dataGraph.report === 'Five Stars-Percentual'">
                            <reportPercentage :dataGraph="dataGraph"/>
                          </template>

                          <template v-if="dataGraph.report === 'Distribuição de notas'">
                            <reportGradeDistribution :dataGraph="dataGraph"/>
                          </template>
                        </template>
                      </div>
                    </grid-item>
                  </grid-layout>
                </div>
              </template>
              <template v-else class="text-center">
                <div class="row mt-4">
                  <div class="col-6 pr-1">
                    <idx-skeleton height="300" radius="6" />
                  </div>
                  <div class="col-6 pl-1">
                    <idx-skeleton height="300" radius="6" />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-12">
                    <idx-skeleton height="300" radius="6" />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-4 pr-1">
                    <idx-skeleton height="300" radius="6" />
                  </div>
                  <div class="col-8 pl-1">
                    <idx-skeleton height="300" radius="6" />
                  </div>
                </div>
              </template>
            </div>

            <b-sidebar
              v-model="showEditPanel"
              id="sidebar-right"
              title="Sidebar"
              width="550px"
              no-header
              style="background: #fff;"
              right
              shadow
            >
              <template v-if="showEditPanel">
                <editCard :dataCard="dataEditCard" />
              </template>
            </b-sidebar>

            <b-sidebar
              v-model="showSidebar"
              id="sidebar-right"
              title="Sidebar"
              width="550px"
              no-header
              style="background: #fff;"
              right
              shadow
            >
              <template>
                <createCard :idPanel="idPanel" />
              </template>
            </b-sidebar>

            <modalAddPanel></modalAddPanel>

            <b-modal
              ok-title="Salvar"
              id="modal-edit-panel"
              title="Editar painel"
              @ok="editPanel"
              centered
              v-b-toggle.sidebar-right
              size="lg"
            >
              <div style="text-align: center;">
                <button class="ball-create-panel">1</button>
                <span>Escolha o tipo do painel</span>

                <button class="ball-create-panel">2</button>
                <span>Configuração do painel</span>
              </div>

              <p class="text-create-panel">Título do painel</p>
              <input v-model="title" class="form-control" />

              <p class="text-create-panel">Descrição</p>
              <textarea v-model="description" class="form-control" />
              <template v-if="userProfile.permissions.panels.share_panel">
                <p class="text-create-panel">Perfis que terão acesso</p>
                <b-form-checkbox-group
                  v-model="perfils"
                  :options="profiles"
                  class="mb-3"
                ></b-form-checkbox-group>
              </template>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import idxSkeleton from '@/components/molecules/idx-skeleton';
import VueGridLayout from 'vue-grid-layout';
import swal from 'sweetalert';
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import createCard from '../../molecules/add-card';
import editCard from '../../molecules/edit-card';
import modalAddPanel from '../../molecules/modal-add-panel';
import analyzeDevice from '../../../assets/analise-dispositivo.png';
import analyzeSentiment1 from '../../../assets/analise-sentimento-1.png';
import analyzeSentiment2 from '../../../assets/analise-sentimento-2.png';
import analyzeSentiment3 from '../../../assets/analise-sentimento-3.png';
import analyzeSentiment4 from '../../../assets/analise-sentimento-4.png';
import analyzeSentiment5 from '../../../assets/analise-sentimento-5.png';
import categories from '../../../assets/categorias.png';
import comparativeActions from '../../../assets/comparativo-ações.png';
import evolutionActions from '../../../assets/evolução-ações.png';
import evolutionInvites from '../../../assets/evolução-convites.png';
import evolutionNps from '../../../assets/evolução-nps.png';
import evolutionPercentage from '../../../assets/evolução-percentuais.png';
import cloudWord from '../../../assets/nuvem-palavras.png';
import addQuestion from '../../../assets/pergunta-adicional.png';
import questionByChannel from '../../../assets/pergunta-por-canais.png';
import ranking from '../../../assets/ranking-pergunta-adicional.png';
import reportComparativeActions from '../../molecules/comparative-actions/panels/index-panels';
import reportBasicColumn from '../../molecules/highcharts/reports/panels/basicColumn-panels';
import reportEvolutionPercentage from '../../molecules/highcharts/reports/panels/evolution-percentage-panels';
import AnswersEvolution from '../../molecules/highcharts/reports/panels/answer-evolution-panels';
import reportDetractor from '../../molecules/highcharts/detractor-report/panels/detractor-report-panels';
import reportAddQuestionReview from '../../molecules/highcharts/reports/rankings/components/panels/reviews';
import reportAddQuestionCsat0a10 from '../../molecules/highcharts/reports/rankings/components/panels/csat';
import reportAddQuestionLikeDislike from '../../molecules/highcharts/reports/rankings/components/panels/like-dislike';
import reportAddQuestionLikert from '../../molecules/highcharts/reports/rankings/components/panels/likert';
import reportAddQuestionEmotion from '../../molecules/highcharts/reports/rankings/components/panels/emotion';
import reportAddQuestionNps from '../../molecules/highcharts/reports/rankings/components/panels/nps';
import reportAddQuestionCes from '../../molecules/highcharts/reports/rankings/components/panels/ces';
import reportAddQuestionMultiple from '../../molecules/highcharts/reports/rankings/components/panels/multiples';
import reportMapChart from '../../molecules/highcharts/map-chart/panels/map';
import reportScoreSentiment from '../../molecules/highcharts/sentment-analysis/panels/score';
import reportSentimentRating from '../../molecules/highcharts/sentment-analysis/panels/chart-sentiment-rating';
import reportCardSentiment from '../../molecules/highcharts/sentment-analysis/panels/cards-sentiment';
import reportEvolutionSentiment from '../../molecules/highcharts/sentment-analysis/panels/evolution-sentiment';
import reportIndicatorSentiment from '../../molecules/highcharts/sentment-analysis/panels/indicator-sentiment';
import reportTopKeywords from '../../molecules/highcharts/sentment-analysis/panels/top-keywords';
import reportConversion from '../../molecules/highcharts/summary-board/panels/conversion';
import reportTreamentStatus from '../../molecules/highcharts/treatment-status/panels/cards-status';
import reportTreamentTags from '../../molecules/highcharts/reports/treatments-tags/panels/treatments-tags';
import reportWordCloud from '../../molecules/highcharts/word-cloud/panels/word-cloud';
import reportSurveyInvites from '../../molecules/highcharts/reports/surveys-invites/panels/surveys-invites';
import reportCategories from '../../molecules/highcharts/reports/categories/panels/categories';
import reportIndicatorsAnalyze from '../../molecules/highcharts/reports/indicators/panels/indicators';
import reportDeviceAnalyze from '../../molecules/highcharts/device-analysis/panels/device-analysis';
import reportInvitesEvolution from '../../molecules/highcharts/reports/treatments-tags/panels/invites-evolution';
import reportAnswersByChannel from '../../molecules/highcharts/reports/answers-by-channel/panels/index';
import reportIndice from '../../molecules/nps-bar/panels/nps-bar';
import reportPercentage from '../../molecules/highcharts/horizontal-bar/panels/horizontal-bar';
import reportGradeDistribution from '../../molecules/highcharts/vertical-column/panels/grade-distribution';
import eventBus from '../../../eventBus';
import api from '../../../services/api';

export default {
  name: 'Panels',
  components: {
    modalAddPanel,
    createCard,
    editCard,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    reportComparativeActions,
    reportBasicColumn,
    reportEvolutionPercentage,
    AnswersEvolution,
    reportDetractor,
    reportAddQuestionReview,
    reportAddQuestionCsat0a10,
    reportAddQuestionLikeDislike,
    reportAddQuestionLikert,
    reportAddQuestionEmotion,
    reportAddQuestionNps,
    reportAddQuestionCes,
    reportAddQuestionMultiple,
    reportMapChart,
    reportScoreSentiment,
    reportSentimentRating,
    reportCardSentiment,
    reportEvolutionSentiment,
    reportIndicatorSentiment,
    reportTopKeywords,
    reportConversion,
    reportTreamentStatus,
    reportTreamentTags,
    reportWordCloud,
    reportSurveyInvites,
    reportCategories,
    reportIndicatorsAnalyze,
    reportDeviceAnalyze,
    reportInvitesEvolution,
    reportAnswersByChannel,
    idxSkeleton,
    reportIndice,
    reportPercentage,
    reportGradeDistribution,
  },
  data: () => ({
    draggable: true,
    resizable: true,
    index: 0,
    columnPanel: 'col-10',
    columnListPanels: 'col-2',
    perfils: [],
    selectedPeriod: 'ultimos 30 dias',
    optionsSelect: [{ value: 'ultimos 30 dias', text: 'Últimos 30 dias' }],
    showSidebar: null,
    selectedReport: null,
    slide: 0,
    title: '',
    description: '',
    selectedMetric: null,
    userAuth: null,
    // showEditPanel: false,
    showAddPanel: false,
    // idPanel: null,
    searchPainel: null,
    listPanels: [],
    dataEditCard: null,
    enabledCustom: true,
    analyzeDevice,
    analyzeSentiment1,
    analyzeSentiment2,
    analyzeSentiment3,
    analyzeSentiment4,
    analyzeSentiment5,
    categories,
    comparativeActions,
    evolutionActions,
    evolutionInvites,
    evolutionNps,
    evolutionPercentage,
    cloudWord,
    addQuestion,
    questionByChannel,
    ranking,
  }),
  watch: {
    idPanel: function watchIdPanel(id) {
      this.idPanel = id;
    },
    panelsInfo: function watchPanelsInfo(value) {
      if (value) {
        document.getElementById('list-panels').style.height = 'auto';
        this.listPanels = this.panelsInfo;
        this.getDataPanel();
      }
    },
    searchPainel: function watchSearchPainel(value) {
      if (value) {
        this.listPanels = this.panelsInfo.filter((panel) => {
          return panel.title.toLowerCase().includes(value.toLowerCase());
        });
      } else {
        this.listPanels = this.panelsInfo;
      }
    },
  },
  computed: {
    ...mapFields('panels', [
      'panelsInfo',
      'showEditPanel',
      'panels',
      'panel',
      'idPanel',
      'loading',
    ]),
    ...mapFields('profiles', ['profiles']),
    ...mapState('companies', ['company']),
    ...mapState('authentication', ['userProfile']),
    ...mapState('branches', ['ih1']),
  },
  methods: {
    ...mapActions('profiles', ['getProfiles']),
    ...mapActions('panels', [
      'setShowEditPanel',
      'setShowSidebar',
      'getAllPanels',
    ]),

    
    returnIh1Names(idIh1){
      
      for (let i = 0; i < this.ih1.listFilters.length; i+=1){
        
          if (this.ih1.listFilters[i]._id === idIh1._id){
            return this.ih1.listFilters[i].corporate_name;
          }
      }

      return "-";
    },

    enabledCustomization(value) {
      if (value === 'open') {
        this.draggable = true;
        this.resizable = true;
        this.enabledCustom = true;
      } else {
        this.draggable = false;
        this.resizable = false;
        this.enabledCustom = false;
      }
    },
    filter(i, period) {
      if (
        this.panel.panelInfo.configGraphs[i].report === 'Evolução de nps' ||
        this.panel.panelInfo.configGraphs[i].report === 'Evolução de ces' ||
        this.panel.panelInfo.configGraphs[i].report === 'Evolução de csat' ||
        this.panel.panelInfo.configGraphs[i].report === 'Evolução de Five Stars' ||
        this.panel.panelInfo.configGraphs[i].report === 'Evolução like/dislike' ||
        this.panel.panelInfo.configGraphs[i].report ===
          'Evolução de percentuais' ||
        this.panel.panelInfo.configGraphs[i].report ===
          'Evolução de respostas' ||
        this.panel.panelInfo.configGraphs[i].report === 'Evolução de convites'
      ) {
        this.panel.panelInfo.configGraphs[i].reportType = period;
        this.forceUpdateProps(i);
      }
    },
    setAccumulated(event, i) {
      this.panel.panelInfo.configGraphs[i].accumulated = event.target.checked;
      this.forceUpdateProps(i);
    },
    forceUpdateProps(i) {
      const _id = this.panel.panelInfo.configGraphs[i]._id;
      // force update component propos by update :key
      this.panel.panelInfo.configGraphs[i]._id = _id + 1;
      setTimeout(() => {
        this.panel.panelInfo.configGraphs[i]._id = _id;
      }, 10);
    },
    reload() {
      this.getDataPanel();
    },
    async layoutUpdatedEvent(newLayout) {
      await api.put(
        `/panel/position`,
        {
          id: this.idPanel,
          layout: newLayout,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
      window.console.log('Updated layout: ', newLayout);
      // this.forceUpdateProps(i);
      this.panel.panelInfo.configGraphs.forEach((el, index) => {
        this.forceUpdateProps(index);
      });
      const response = await api.get(`/get/panel/${this.idPanel}`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          idPanel: this.idPanel,
        },
      });
      this.panel = response.data;
    },
    itemTitle(item) {
      let result = item.i;
      if (item.static) {
        result += ' - Static';
      }
      return result;
    },
    async editPanel() {
      await api.put(
        '/update/panel',
        {
          idPanel: this.idPanel,
          title: this.title,
          description: this.description,
          perfils: this.perfils,
        },
        { headers: { 'x-access-token': this.userAuth.token } },
      );
      this.getAllPanels({
        token: this.userAuth.token,
      });
      swal({
        text: 'Editado com sucesso!',
        icon: 'success',
      });
    },
    getPanelEditData() {
      if (this.panelsInfo.length > 0) {
        for (let i = 0; i < this.panelsInfo.length; i += 1) {
          if (this.panelsInfo[i]._id === this.idPanel) {
            this.title = this.panelsInfo[i].title;
            this.description = this.panelsInfo[i].description;
            this.perfils = this.panelsInfo[i].perfils;
          }
        }
      }
    },
    async showSidebarEdit(idCard) {
      const response = await api.get(`/get/card/${idCard}`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          idPanel: this.idPanel,
        },
      });
      await this.setShowEditPanel(true);

      this.dataEditCard = response.data;
    },
    async showAddGraphic() {
      await this.setShowSidebar(true);
    },
    onSlideStart() {
      if (this.slide !== this.slide.length - 1) {
        this.slide = this.slide + 1;
      }
    },
    onSlideEnd() {
      if (this.slide !== 0) {
        this.slide = this.slide - 1;
      }
    },
    async selectPanel(idPanel) {
      this.replaceQueryParams({
        idpanel: idPanel,
      });
      // document.getElementById(`${idPanel}`).style.backgroundColor = '#F0F6FB';
      // document.getElementById(`${idPanel}`).style.color = '#3DB374';
      this.idPanel = idPanel;
      await this.getDataPanel();
    },
    replaceQueryParams(object) {
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, ...object },
      });
    },
    deleteCard(idGraph) {
      swal({
        title: `${this.$t('panel.pageHome.wouldDeleteCard')}`,
        text: `${this.$t('panel.pageHome.description')}`,
        icon: 'warning',
        className: 'customSwal',
        buttons: {
          Não: { text: `${this.$t('panel.pageHome.no')}`, value: false, className: 'btn-no' },
          Sim: { text: `${this.$t('panel.pageHome.yes')}`, value: true, className: 'btn-yes' },
        },
      }).then(async (willDelete) => {
        if (willDelete) {
          await api.delete(`/delete/card/${idGraph}`, {
            headers: {
              'x-access-token': this.userAuth.token,
            },
            data: {
              idPanel: this.idPanel,
            },
          });
          swal({
            text: 'Deletado com sucesso!',
            icon: 'success',
          });
          this.getAllPanels({
            token: this.userAuth.token,
          });
        }
      });
    },
    async deletePainel() {
      swal({
        title: `${this.$t('panel.pageHome.wouldDelete')}`,
        text: `${this.$t('panel.pageHome.description')}`,
        icon: 'warning',
        className: 'customSwal',
        buttons: {
          Não: { text: `${this.$t('panel.pageHome.no')}`, value: false, className: 'btn-no' },
          Sim: { text: `${this.$t('panel.pageHome.yes')}`, value: true, className: 'btn-yes' },
        },
      }).then(async (willDelete) => {
        if (willDelete) {
          await api.delete(`/delete/panel/${this.idPanel}`, {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          });
          swal({
            text: 'Deletado com sucesso!',
            icon: 'success',
          });
          this.getAllPanels({
            token: this.userAuth.token,
          });
        }
      });
    },
    hide() {
      document.getElementById('list-panels').style.width = '10px';
      document.getElementById('list-panels').style.minWidth = '10px';
      document.getElementById('content-panels').style.marginLeft = '20px';
      document.getElementById('title').style.display = 'none';
      document.getElementById('button-hide').style.display = 'none';
      document.getElementById('button-show').style.display = 'block';
      this.columnPanel = 'col-12';
      this.columnListPanels = 'col-2';
    },
    show() {
      document.getElementById('list-panels').style.width = '250px';
      document.getElementById('list-panels').style.minWidth = '250px';
      document.getElementById('content-panels').style.marginLeft = '255px';
      document.getElementById('title').style.display = 'block';
      document.getElementById('button-hide').style.display = 'block';
      document.getElementById('button-show').style.display = 'none';
      this.columnPanel = 'col-10';
      this.columnListPanels = 'col-2';
    },
    async getDataPanel() {
      if (this.idPanel) {
        this.loading = true;
        const response = await api.get(`/get/panel/${this.idPanel}`, {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            idPanel: this.idPanel,
          },
        });
        

        const configGraphs = response.data.panelInfo.configGraphs.map((a) => {
          return {
            ...a,
            reportType: a.reportType ? a.reportType : "month"
          };
        });
        const panelInfo = {
          ...response.data.panelInfo,
          configGraphs,
        };
        this.panel = {
          layout: response.data.layout,
          panelInfo,
        };
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getDataPanel();
    eventBus.$emit('change-padding', true);
  },
  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.listPanels = this.panelsInfo;

    if (this.panelsInfo.length > 0) {
      this.replaceQueryParams({
        idpanel: this.panelsInfo[0]._id,
      });
      this.idPanel = this.panelsInfo[0]._id;
      this.getDataPanel();
    }else{
      this.replaceQueryParams({ 'idpanel': undefined });
    }

    await this.getAllPanels({
      token: this.userAuth.token,
    });
    if (this.panelsInfo.length > 0) {
      document.getElementById('list-panels').style.height = '0';
    }
    await this.getProfiles({
      token: this.userAuth.token,
      companyId: this.userAuth.companyId,
    });
    eventBus.$on('update-cards', () => {
      this.getDataPanel();
    });
  },
};
</script>

<style>
/* .swal-button {
  text-align: center;
}
.swal-button--cancel {
  width: 142px;
  background: #7ab4f2;
  color: #fff;
}
.swal-footer {
  text-align: center;
} */
</style>

<style lang="scss" scoped>
.ellipsis-panel{
  float: left;
  margin-top: -5px;
  position: absolute;
  color: #c1c1c1;
}

.text-create-panel {
  margin-top: 10px;
  margin-bottom: 2px;
}
.col-10 {
  padding-right: 0;
}
.col-lg {
  max-width: 100%;
  padding-right: 0;
}
.custom-buttons {
  text-align: center;
}
@media (max-width: 1000px) {
  .custom-buttons {
    text-align: right;
  }
}
.fixed-menu {
  position: fixed;
  height: 100vh !important;
  width: 250px;
  background: #fff;
}
.button-group {
  background: #f0f6fb;
  border-radius: 50rem;
  padding-left: 15px;
  padding-right: 15px;
  margin-left: 90px;
}
.buttons-filters {
  background: #f0f6fb;
  // border-radius: 20px;
  // padding-left: 15px;
  // padding-right: 15px;
  border: none;
  outline: none;
  font-size: 12px;
}
.buttons-filters.active {
  font-weight: bold;
  background: #fff !important;
  // border-radius: 20px !important;
  // padding-left: 15px !important ;
  // padding-right: 15px !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}
.selected {
  background: #fff !important;
  // border-radius: 20px !important;
  // padding-left: 35px !important ;
  // padding-right: 35px !important;
  border-color: green !important;
}
.icons-grid {
  padding-left: 16px;
  > i {
    opacity: 0.7;
    transition: all 0.2s linear;
    cursor: pointer;
    &:hover {
      opacity: 1;
    }
  }
}
.filters {
  font-weight: 400;
  font-size: 12px;
  margin: 0;
  border-right: 1px solid #c1c1c1;
  padding-right: 10px;
  padding-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.vue-grid-item:not(.vue-grid-placeholder) {
  background: #fff;
  border: 1px solid #fff;
}
.btn-popover {
  background: #fff;
  border: none;
  font-size: 12px;
  outline: 0;
}
.btn-more-search {
  background: transparent;
  color: #4ce595;
  border: none;
}
.btn-more-search:active,
.btn-more-search:focus {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}
#button-hide {
  position: absolute;
  right: -15px;
  top: -10px;
  background: #ffffff;
  z-index: 999;
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 50%;
  color: #4ce595;
}
#button-show {
  position: absolute;
  left: 0;
  top: 10px;
  background: #ffffff;
  z-index: 999;
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 50%;
  color: #4ce595;
}
.panel-item {
  text-align: left;
  border-radius: 0;
  background: #ffffff;
  border: none;
  border-bottom: solid 1px #f0f6fb;
  font-weight: normal;
}
.panel-item.active {
  background: #f0f6fb;
  color: #4ce595;
  border-right: solid 4px #4ce595;
}
.col-lg {
  max-width: 99%;
}
#main-painel {
  display: flex;
}
#no-panel {
  font-weight: 600;
  font-size: 26px;
  line-height: 24px;
}
#list-panels {
  height: 100vh !important;
  background: #fff !important;
  width: 250px;
  min-width: 250px;
  position: fixed;
}
#content-panels {
  margin-left: 255px;
}
#title {
  padding-top: 20px;
  font-weight: 700;
  text-align: center;
  font-size: 16px;
  line-height: 12px;
}
.add-panel {
  padding: 8px, 14px, 8px, 14px;
  border-radius: 4px;
  width: 460px;
  height: 54px;
  background: #ffffff;
  border: 1px solid #4ce595;
  color: #4ce595;
  outline-style: none;
}
.add-panel:hover {
  outline-style: none;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}
#msg-no-panel {
  margin-bottom: auto;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10%;
  text-align: center;
}
#button-show {
  display: none;
}
.btn-arrow {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  color: #3db374;
  background: #ffffff;
  border: 1px solid #3db374;
  padding: 0;
  /* margin-left: 208px;
  margin-top: -55px; */
  color: #3db374;
  /* position: absolute; */
}
.btn-arrow:hover {
  color: #3db374;
}
.bar {
  background: #fff;
  height: 75px;
  margin-top: 10px;
  padding: 18px;
}
.title-bar {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #242424;
}
.content {
  height: 100%;
  width: 100%;
  /* border: 2px solid rgb(32, 31, 31); */
  background: #fff;
  border-radius: 5px;
}
.vertical-bar {
  height: 2px;
  border-right: 2px solid #ccc;
  margin-left: 20px;
  margin-right: 20px;
}
.text {
  margin-left: 15px;
  margin-bottom: 5px;
  background: #fff;
  padding: 0;
  border: none;
}
.text:hover {
  color: #3db374;
  background: #fff;
}
.text:focus {
  box-shadow: none;
  outline: 0;
}
.ball-create-panel {
  border-radius: 50%;
  display: inline-table;
  height: 25px;
  color: #fff;
  width: 25px;
  font-size: 14px;
  border: 1px solid #3db374;
  background-color: #3db374;
}
.btn-more {
  padding: 0;
  height: 30px;
  width: 30px;
  border-radius: 30px;
}
.description {
  font-weight: 400;
  font-size: 12px;
  color: #242424;
}
.b-sidebar-outer {
  z-index: 1040;
}
.create-card {
  font-weight: 700;
  font-size: 26px;
  line-height: 28px;
}
.card-description {
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
}
.main-sidebar {
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 12px;
  background: #fff;
}
.label-text {
  margin-bottom: 0;
  margin-top: 15px;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
}
#panels {
  margin-left: -10px;
  margin-right: -10px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/panels/index.vue